import React, { Component } from "react"
import classes from "./navbar.module.scss"
import SideMenu from "./sidemenu/sideMenu"
import Hamburger from "./hamburger/hamburger"
import Modal from "../modal/modal"
import Button from "../UI/button/button"
import { Link } from "react-scroll"

class navbar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      menuOpen: false,
      modalOpen: false,
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleEsc)
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction)
  }

  handleEsc = event => {
    if (event.keyCode === 27) {
      this.CloseModal()
    }
  }

  ToggleMenu = () => this.setState({ menuOpen: !this.state.menuOpen })
  ModalOpen = () => this.setState({ modalOpen: true })
  CloseModal = () => this.setState({ modalOpen: false })

  render() {
    let ModalVar = ""
    if (this.state.modalOpen) {
      ModalVar = <Modal CloseModal={this.CloseModal} />
    }
    return (
      <header className={classes.container}>
        {ModalVar}
        <div className={classes.wrapper}>
          <h1 className={classes.title}>IT Arnas</h1>

          <Hamburger menuOpen={this.ToggleMenu} />

          {this.state.menuOpen ? (
            <SideMenu OpenSideMenuModal={this.props.OpenSideMenuModal} />
          ) : (
            ""
          )}

          <div>
            <ul className={classes.ul}>
              <li className={classes.li}>
                <Link
                  to="home"
                  className={classes.Link}
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  Pradžia
                </Link>{" "}
              </li>
              <li className={classes.li}>
                <Link
                  to="favours"
                  className={classes.Link}
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  Paslaugos
                </Link>
              </li>
              <li className={classes.li}>
                <Link
                  to="portfolio"
                  className={classes.Link}
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  Portfolio
                </Link>
              </li>
              <li className={classes.li}>
                <Button onClick={this.ModalOpen}>Kontaktai</Button>
              </li>
            </ul>
          </div>
        </div>
      </header>
    )
  }
}

export default navbar
